import { Component, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { GeometryLayer } from '../models/geometry-layer.model';
import { Geometry, GISPoint, GISPolyline, GISPolygon, GeometryType, ConfigurationComponent } from '../models/geometry.model';
import { GeometryManagerComponent } from '../geometry-manager.component';
import { Rule } from "../../../../../../../../../../common/models/flow.dto";

@Component({
    selector: 'geometric-layer',
    templateUrl: './geometric-layer.component.html',
    styleUrls: ['./geometric-layer.component.scss'],
    standalone: false
})
export class GeometricLayerComponent {
    @Input()
    layer: GeometryLayer;
    geometryTypes = Object.values(GeometryType);
    inEdit: boolean = false;
    form: FormGroup;
    geometry: any[];
    showConditionalEditor: boolean = false;

    constructor(
        public _manager: GeometryManagerComponent
    ) { }

    ngOnInit() {
        if (this.layer.isConditional === undefined) this.layer.isConditional = false;
        this.showConditionalEditor = this.layer.isConditional;        
        this.form = new FormGroup({
            title: new FormControl(this.layer.title),
            identifier: new FormControl(this.layer.identifier),
            isConditional: new FormControl(this.layer.isConditional),
            color: new FormControl(this.layer.color || '#000000')
        });
        this.geometry = Object.assign([], this.layer.geometry) || [];
    }

    createGeometry(type: GeometryType) {
        switch (type) {
            case GeometryType.Point:
                this.geometry.push(new GISPoint());
                break;
            case GeometryType.polygon:
                this.geometry.push(new GISPolygon());
                break;
            case GeometryType.polyline:
                this.geometry.push(new GISPolyline());
                break;
        }
    }

    cancel() {
        this.inEdit = false;
        this.geometry = Object.assign([], this.layer.geometry) || [];
    }

    save() {
        for (var prop in this.form.controls)
            this.layer[prop] = this.form.get(prop).value;

        this.layer.geometry = this.geometry;
        this.inEdit = false;
    }

    delete() {
        this._manager.delete(this.layer);
    }

    ruleCompiled(e: Rule): void {
        this.layer.rule = e;
    }

    toggleEditor(): void {        
        this.showConditionalEditor = !this.showConditionalEditor;
    }
}